import React, { useEffect, useRef, useState } from "react";
import CommonLayout from "../../CommonLayout/CommonLayout";
import styles from "../../../Pages/Users/Users/users.module.css";
import { TfiMenuAlt } from "react-icons/tfi";
import { PiSquaresFour } from "react-icons/pi";
import { RiArrowDropDownFill } from "react-icons/ri";
import { CiSearch } from "react-icons/ci";
import WeekRangeDropdown from "../../Dropdown/WeekRange";
import CalendarComp from "../../CalendarComp/CalendarComp";
import SelectDropdown from "../../Dropdown/SelectDropdown";
import { Dropdown } from "primereact/dropdown";

const FiltersComp = ({
  gridToggle,
  SetGridToggle,
  layoutView,
  SearchBy,
  handleSearch,
  handleFilter,
  handleClearFilter,
  filters,
  WeekRange,
  MonthRange,
  canlenderFilter,
  actionButton,
}) => {
  const [clear, setClear] = useState(false);
  const search = useRef();

  return (
    <>
      <div className={styles.subcontainer1}>
        {layoutView ? (
          <>
            <div
              onClick={() => SetGridToggle(false)}
              style={{ cursor: "pointer" }}
            >
              <TfiMenuAlt
                size={"1.3rem"}
                color={gridToggle ? "black" : "#e34e4e"}
              />
            </div>
            <div
              onClick={() => SetGridToggle(true)}
              style={{ cursor: "pointer" }}
            >
              <PiSquaresFour
                size={"1.9rem"}
                color={!gridToggle ? "black" : "#e34e4e"}
              />
            </div>
          </>
        ) : null}
        {SearchBy.options.length ? (
          <SelectDropdown
            inputName={SearchBy.inputName}
            placeholder={SearchBy.filterType}
            options={SearchBy.options}
            handleFilter={handleFilter}
            setClear={setClear}
            clear={clear}
            sx={{ border: "1px solid var(--color--11)" }}
          />
        ) : null}
        {SearchBy.options.length ? (
          <div className={styles.border_search}>
            <input
              ref={search}
              // value={clear?"":}
              type="text"
              style={{
                border: "none",
                outline: "none",
                backgroundColor: "transparent",
              }}
              // className={styles.border_search}
              placeholder="Search"
              onChange={(e) => {
                // console.log("search",e.target.value);
                handleSearch && handleSearch(e.target.value);
              }}
            />
            <CiSearch size={"1.1rem"} />
          </div>
        ) : null}
        {Array.isArray(filters) &&
          filters.map((f, i) => (
            <SelectDropdown
              key={i}
              inputName={f.inputName}
              placeholder={f.filterType}
              options={f.options}
              handleFilter={handleFilter}
              setClear={setClear}
              clear={clear}
              sx={{ border: "1px solid var(--color--11)" }}
            />
          ))}

        {WeekRange ? <WeekRangeDropdown handleFilter={handleFilter} /> : ""}
        {MonthRange ? (
          <CalendarComp
            canlenderFilter={canlenderFilter}
            handleFilter={handleFilter}
            sxCal={{
              border: "1px solid var(--color--11)",
              borderRadius: "20px",
            }}
          />
        ) : (
          ""
        )}

        {SearchBy.options.length ? (
          <>
            <div>
              <button
                onClick={() => {
                  setClear(true);
                  search.current.value = "";
                  handleSearch && handleSearch("");
                  handleClearFilter && handleClearFilter();
                }}
                className={styles.border}
              >
                Clear Filter
              </button>
            </div>
          </>
        ) : null}

        {actionButton && (
          <button
            className={styles.border_apply}
            onClick={actionButton.handleButton}
          >
            {actionButton?.button_name}
          </button>
        )}
      </div>
    </>
  );
};

export default FiltersComp;
